import { useCallback } from 'react'
import { useReactiveVar } from '@apollo/client'

import { useTransactionFilters } from 'hooks/useTransactionFilters'
import { DashboardFiltersButton } from 'layouts/DashboardLayout'

import { useContactContext } from '../../../ContactContext/ContactContext'
import { rvIsContactPaymentFiltersDisabled } from '../../../rv-deprecated/contacts'

export const ContactFiltersButtonDeps = {
  useContactContext,
  useReactiveVar,
  useTransactionFilters,
}

export const ContactFiltersButton = () => {
  const { useContactContext, useReactiveVar, useTransactionFilters } =
    ContactFiltersButtonDeps

  const { isPaymentsFiltersVisible, setIsPaymentsFiltersVisible } =
    useContactContext()

  const isContactPaymentFiltersDisabled = useReactiveVar(
    rvIsContactPaymentFiltersDisabled
  )

  const { areFiltersInDefaultState } = useTransactionFilters()

  const handleOnClick = useCallback(() => {
    setIsPaymentsFiltersVisible((prev) => !prev)
  }, [setIsPaymentsFiltersVisible])

  return (
    <DashboardFiltersButton
      disabled={isContactPaymentFiltersDisabled}
      isActive={isPaymentsFiltersVisible}
      onClick={handleOnClick}
      showIndicator={!areFiltersInDefaultState}
    />
  )
}
